import { DESKTOP_SPACING } from "@/theme";
import styled from "styled-components";

export const StyledSmallButtons = styled.div`
  display: inline-flex;
  justify-content: flex-start;
  gap: ${DESKTOP_SPACING.XL}px;
`;
